
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class LhdTable extends Vue {
    //龙虎斗
    table = {
        data: [],
        column: [
            {
                key: 'dragon',
                title: '下注龙金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.dragon) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.dragon.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.dragon.bet)
                        }
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'tiger',
                title: '下注虎金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.tiger) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.tiger.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.tiger.bet)
                        }
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'mix',
                title: '下注和金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.mix) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.mix.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.mix.bet)
                        }
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'total_bet',
                title: '是否上庄',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).hits.is_banker ? '是' : '否'
                    return h('span', str)
                }
            },
            {
                key: 'b_dealer',
                title: '牌型(龙)',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    let str: any
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        strzo = JSON.parse(params.row.opt_detail).award_content.point.dragon
                        str = "<img style='width:35px;' src=img/poker/" + strzo + '.png>'
                        return h('div', {
                            style: {
                                marginTop: '5PX'
                            },
                            domProps: {
                                innerHTML: str
                            }
                        })
                    } else {
                        return h('span', '/')
                    }
                }
            },
            {
                key: 'b_dealer',
                title: '牌型(虎)',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    let str: any
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        strzo = JSON.parse(params.row.opt_detail).award_content.point.tiger
                        str = "<img style='width:35px;' src=img/poker/" + strzo + '.png>'
                        return h('div', {
                            style: {
                                marginTop: '5PX'
                            },
                            domProps: {
                                innerHTML: str
                            }
                        })
                    } else {
                        return h('span', '/')
                    }
                }
            },
            {
                key: 'total_win',
                title: '输赢',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.total_win) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.total_win)
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            }
        ]
    }
    @Prop()
    listdata
}
